import axios from "axios";
import api from "./api";

const askBenthos = async ({ question, abort }) => {
  try {
    const response = await api.post(
      "/chat",
      { input: question },
      {
        signal: abort,
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled");
    }
    console.log("🚀 ~ askBenthos ~ error:", error);
  }
};

export default askBenthos;
